import axios from '@/libs/axios'

const recordCatchActions = {
    fetchRecordCatches({commit, dispatch}, searchParams) {
        return axios.get('/record-catches', {params: searchParams})
    },
    exportRecordCatchList({commit, dispatch}, searchParams) {
        return axios.get('/record-catches/export', {params: searchParams, responseType: 'blob'})
    },
    downloadRecordCatchImportSample() {
        return axios.post('/imports/record-catches/download-sample', [], {responseType: 'blob'})
    },
    getRecordCatchImportValidationRules() {
        return axios.post('/imports/record-catches/validation-rules')
    },
    loadRecordCatchImportPreview({commit, dispatch}, data) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        };

        return axios.post('/imports/record-catches/load-preview', data, config)
    },
    recordCatchImport({commit, dispatch}, data) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        };

        return axios.post('/imports/record-catches/import', data, config)
    },
    fetchRecordCatch({commit, dispatch}, id) {
        return axios.get(`/record-catches/${id}`)
    },
    storeRecordCatch({commit, dispatch}, data) {
        return axios.post('/record-catches', data)
    },
    updateRecordCatch({commit, dispatch}, data) {
        return axios.put(`/record-catches/${data.id}`, data)
    },
    deleteRecordCatch({commit, dispatch}, id) {
        return axios.delete(`/record-catches/${id}`)
    },
    getImagesForRecordCatch({commit, dispatch}, data) {
        return axios.get(`/record-catches/images/${data.id}`)
    },
    storeImagesForRecordCatch({commit, dispatch}, data) {
        return axios.post('/record-catches/images', data)
    },
    setPrimaryImageForRecordCatch({commit, dispatch}, data) {
        return axios.post(`/record-catches/image/${data.id}/primary`)
    },
    setImagePr({commit, dispatch}, data) {
        return axios.post(`/record-catches/image/${data.id}/pr`)
    },
    setImageVisible({commit, dispatch}, data) {
        return axios.post(`/record-catches/image/${data.id}/visible`)
    },
    deleteImage({commit, dispatch}, id) {
        return axios.delete(`/record-catches/image/${id}/delete`)
    },
    orderImagesForRecordCatch({commit, dispatch}, data) {
        return axios.post(`/record-catches/images/${data.id}/order`, data)
    },
}

export default recordCatchActions
